import { render } from "./O_monitoringData.vue?vue&type=template&id=64361447&scoped=true"
import script from "./O_monitoringData.vue?vue&type=script&lang=js"
export * from "./O_monitoringData.vue?vue&type=script&lang=js"

import "./O_monitoringData.vue?vue&type=style&index=0&id=64361447&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64361447"]])

export default __exports__